"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const uswds_react_utils_1 = require("@boozallen-uip/uswds-react-utils");
const IconListContent_1 = __importDefault(require("./IconListContent"));
const IconListIcon_1 = __importDefault(require("./IconListIcon"));
const IconListItem_1 = __importDefault(require("./IconListItem"));
const IconListComponent = (0, react_1.forwardRef)(({ children, className, color, size, ...props }, ref) => {
    return ((0, jsx_runtime_1.jsx)("ul", { ref: ref, className: (0, uswds_react_utils_1.createClassString)('usa-icon-list', color && `usa-icon-list--${color}`, size && `usa-icon-list--size-${size}`, className), ...props, children: children }));
});
const IconList = Object.assign(IconListComponent, { Content: IconListContent_1.default, Icon: IconListIcon_1.default, Item: IconListItem_1.default });
exports.default = IconList;
